<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           :popup-message="getPopupMessage"
           @popup-action="executePopupAction">
    </popup>
    <div class="inner">
      <p class="paging">
        <router-link :to="{ name: moduleName, params: { tab: tabName} }" class="btn btn_back" v-translate>Seznam
        </router-link>
      </p>
      <p class="buttons">
        <a v-if="$_loggedUser_action_allowed('messages', 'create')"
           class="btn btn_action btn_grey btn_notification"
           :title="'Odeslat oznámení' | translate"
           @click.prevent.stop="newMessage" v-translate>Odeslat oznámení</a>
        <a v-if="!entity.active && $_updateActionAllowed"
           class="btn btn_action btn_grey btn_enable"
           :title="'Aktivovat' | translate"
           @click.prevent.stop="updateEntityActive('active', true)"
           v-translate>Aktivovat</a>
        <a v-if="entity.active && $_updateActionAllowed"
           class="btn btn_action btn_grey btn_disable"
           :title="'Deaktivovat' | translate"
           @click.prevent.stop="updateEntityActive('active', false)"
           v-translate>Deaktivovat</a>
        <a v-if="$_updateActionAllowed"
           class="btn btn_action btn_grey btn_refresh"
           :title="'Smazat cache všech zařízení odběratele' | translate"
           @click.prevent.stop="deleteSubscriberDevicesCache"
           v-translate>Smazat cache všech zařízení odběratele</a>
        <a v-if="$_deleteActionAllowed"
           class="btn btn_action btn_delete"
           :title="'Smazat' | translate"
           @click.prevent.stop="deleteEntity"
           v-translate>Smazat</a>
      </p>
      <h1 v-if="hasName">{{ entity.surname }} {{ entity.firstname }}
        <span>{{ companyTown }}</span>
      </h1>
    </div>

    <div id="responsiveTabs" class="responsiveTabs r-tabs">
      <ul class="tabs r-tabs-nav">
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailSettings'}">
          <a @click.stop="openRoute('subscriberDetailSettings')" v-translate>Vlastnosti</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailBiller'}">
          <a @click.stop="openRoute('subscriberDetailBiller')" v-translate>Plátce</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailServices'}">
          <a @click.stop="openRoute('subscriberDetailServices')" v-translate>Služby</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailDevices'}">
          <a @click.stop="openRoute('subscriberDetailDevices')" v-translate>Zařízení</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailProfiles'}">
          <a @click.stop="openRoute('subscriberDetailProfiles')" v-translate>Profily</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailChannelGroups'}">
          <a @click.stop="openRoute('subscriberDetailChannelGroups')" v-translate>Skupiny stanic</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailPvrs'}">
          <a @click.stop="openRoute('subscriberDetailPvrs')" v-translate>Nahrávky</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailPeriodicPvrs'}">
          <a @click.stop="openRoute('subscriberDetailPeriodicPvrs')" v-translate>Pravidelné nahrávky</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailFavoriteShows'}">
          <a @click.stop="openRoute('subscriberDetailFavoriteShows')" v-translate>Oblíbené pořady</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailMessages'}">
          <a @click.stop="openRoute('subscriberDetailMessages')" v-translate>Oznámení</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailAdvertisingBanners'}">
          <a @click.stop="openRoute('subscriberDetailAdvertisingBanners')" v-translate>Marketingová oznámení</a>
        </li>
        <!-- dočasně skryto (TW 36504111)
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailNotifications'}">
          <a @click.stop="openRoute('subscriberDetailNotifications')" v-translate>Oznámení pořadů</a>
        </li>
        -->

        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailDashboard'}">
          <a @click.stop="openRoute('subscriberDetailDashboard')" v-translate>Dashboard</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailRestrictedChannels'}">
          <a @click.stop="openRoute('subscriberDetailRestrictedChannels')" v-translate>Restrikce kanálů</a>
        </li>
        <li :class="{'r-tabs-state-active' : this.$route.name === 'subscriberDetailPurchasedVodVideos'}">
          <a @click.stop="openRoute('subscriberDetailPurchasedVodVideos')" v-translate>Zakoupená TVOD videa</a>
        </li>
      </ul>

      <keep-alive>
        <router-view
            v-if="entity.id"
            :entity="entity"
            :isEditable="$_updateActionAllowed"
            :oldEmail="oldEmail"
            :ref="$route.name"
            @set-password="setNewPassword"
            @getEntity="getEntity"
            @submitForm="submitForm"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import subscribers from "@/components/views/subscribers/mixins/subscribers"
import subscriberData from "@/components/mixins/subscriber-data"
import selectOperator from "@/components/mixins/select-operator-business-model"

export default {
  name: "SubscriberDetail",
  mixins: [detailActions, subscriberData, subscribers, selectOperator],
  data: function () {
    return {
      oldEmail: null,
    }
  },
  created(
      SubscriberService,
  ) {
    this.entityService = SubscriberService

    this.createdInit()
        .then(() => {
          this.oldEmail = this.entity.email;
          if (this.$route.params.remote && this.entity && this.entity.id) {
            this.$router.replace({name: 'subscriberDetailSettings', params: {id: this.entity.id}})
          }
        })
  },
  methods: {
    submitForm(redirect = false) {
      this.updateEntity(this.entity, redirect)
          .then(() => {
            this.oldEmail = this.entity.email;
          })
    },
    executePopupAction(value) {
      if (value === true) {
        if (this.getPopupAction === 'delete') {
          this.deleteEntity(false)
        }
        if (this.getPopupAction === 'delete-service') {
          this.$refs['subscriberDetailServices'].deleteSubscriberService(this.getPopupId, false)
        }
        if (this.getPopupAction === 'delete-device' || this.getPopupAction === 'delete-device-multi') {
          this.$refs['subscriberDetailDevices'].deleteDevice(this.getPopupId, false)
        }
        if (this.getPopupAction === 'delete-pairing-code') {
          this.$refs['subscriberDetailDevices'].deletePairingCode(this.getPopupId, false)
        }
        if (this.getPopupAction === 'deleteMessage') {
            this.$refs['subscriberDetailMessages'].onDeleteMessage(this.getPopupId, false)
        }
        if (this.getPopupAction === 'deleteAdvertisingBanner') {
            this.$refs['subscriberDetailAdvertisingBanners'].onDeleteAdvertisingBanner(this.getPopupId, false);
        }
        if (this.getPopupAction === 'deleteSubscriberNotification') {
          this.$refs['subscriberDetailNotifications'].onDeleteSubscriberNotification(this.getPopupId, false);
        }
        if (this.getPopupAction === 'deletePvr') {
            this.$refs['subscriberDetailPvrs'].onDeletePvr(this.getPopupId, false)
        }
        if (this.getPopupAction === 'deleteProfile') {
          this.$refs['subscriberDetailProfiles'].deleteProfile(this.getPopupId, false)
        }
        if (this.getPopupAction === 'reset-channel-group') {
          this.$refs['subscriberDetailChannelGroups'].onResetChannelGroup(this.getPopupId, false)
        }
        if (this.getPopupAction === 'delete-channel-group') {
          this.$refs['subscriberDetailChannelGroups'].onRemoveChannelGroup(this.getPopupId, false)
        }
        if (this.getPopupAction === 'deleteFavoriteShow') {
          this.$refs['subscriberDetailFavoriteShows'].onDeleteFavoriteShow(this.getPopupId, false)
        }
        if (this.getPopupAction === 'deletePeriodicPvr') {
          this.$refs['subscriberDetailPeriodicPvrs'].onDeletePeriodicPvr(this.getPopupId, false)
        }
        if (this.getPopupAction === 'deleteVideo') {
          this.$refs['subscriberDetailPurchasedVodVideos'].onDeletePurchasedVideo(this.getPopupId, false);
        }
      }
      this.hidePopup()
    },
    deleteSubscriberDevicesCache() {
      this.entityService.deleteSubscriberDevicesCache(this.entity.id)
          .then(() => {
            this.setSuccessMessage()
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message'])
          })
    },
    newMessage(){
      this.$router.push({name: 'messageNew', params: {recipient_subscriber_id: this.entity.id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/SubscriberDetail.vue